import React from 'react';

import {
	AiCornerAgentWithContext,
	handleWidgetPosition,
	useOptionalAiWidgetConfig,
} from '@atlassian/csm-ai-search-trigger';

export const AiCornerAgentRenderer = (): React.JSX.Element | null => {
	const aiWidgetConfig = useOptionalAiWidgetConfig();
	const supportWidgetConfig = aiWidgetConfig?.supportWidgetConfig;

	const isSSR =
		typeof window !== 'undefined' && (!!process.env.REACT_SSR || !!window.__SSR_RENDERED__);

	const showCornerAgent = Boolean(
		!isSSR &&
			supportWidgetConfig &&
			supportWidgetConfig.isEnabled &&
			handleWidgetPosition(supportWidgetConfig.widgetPosition) === 'CORNER',
	);

	return showCornerAgent ? <AiCornerAgentWithContext /> : null;
};
